module.exports = __webpack_public_path__ + "img/healthgrade.c028cb4a.png";